import { useMemo } from 'react';

export const useRows = (data) =>
  useMemo(() => {
    return Object.entries(data).map(([key, value]) => {
      const items = value.map((item) => {
        const [name, empNumber, startDate, endDate, jobCode, payCode, hours] =
          item;

        return { name, startDate, endDate, hours, empNumber, jobCode, payCode };
      });

      return { title: key, items };
    });
  }, [data]);
